import { type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Route } from '@constants/routes';
import { type StandardProfileFragmentFragment } from '@gql/graphql';
import { formatDate } from '@utils/dateFormatUtils';

interface StandardProfileLinkProps {
    profile: Partial<StandardProfileFragmentFragment>;
    label?: string;
    openInNewTab?: boolean;
    zoneId?: string;
    projectId?: string;
}

export function StandardProfileLink(
    params: StandardProfileLinkProps,
): ReactNode {
    const {
        profile,
        label: labelProps,
        openInNewTab,
        zoneId,
        projectId,
    } = params;

    const dateString = profile.standard?.releasedAt
        ? formatDate(profile.standard.releasedAt)
        : '';
    const dateStringLabel = dateString ? `- ${dateString}` : '';
    const defaultLabel = `${profile.standard?.name} (${profile.alias}) ${dateStringLabel}`;

    const displayLabel = labelProps || defaultLabel;

    // Determine the route based on whether zoneId and projectId are provided
    const linkRoute =
        zoneId && projectId
            ? Route.ProjectZoneRequirements(projectId, zoneId, profile.id ?? '')
            : Route.StandardProfileRequirements(
                  profile.standard?.id ?? '',
                  profile.id ?? '',
              );

    return (
        <Link
            className="text-se70"
            to={linkRoute}
            target={openInNewTab ? '_blank' : '_self'}
        >
            {displayLabel}
        </Link>
    );
}
